import { API_V4 } from "@/services/config/auth-axios";

class GiftsService {
  getGifts() {
    return API_V4.get("/gifts/index");
  }
  getGiftsPagination(pageNumber) {
    return API_V4.get(`/gifts/index?page=${pageNumber}`);
  }
  rewards() {
    return API_V4.get("/gifts/rewards");
  }
  getPage() {
    const lang = localStorage.getItem("lang");
    return API_V4.get(`/core/pages/rewards-page/${lang}`);
  }
}

export default new GiftsService();
